import { useSyncExternalStore } from 'react';
import { getTargetAttackUiSnapshot, subscribeTargetAttackUi } from '../../state/targetAttackUiStore.ts';
import { TARGET_ATTACK_DOM } from './targetAttackDomIds.ts';
import { useI18n } from 'shared/lib/i18n.tsx';

export function TargetAttackGameOver() {
  const d = TARGET_ATTACK_DOM;
  const { t } = useI18n();
  const s = useSyncExternalStore(
    subscribeTargetAttackUi,
    getTargetAttackUiSnapshot,
    getTargetAttackUiSnapshot,
  );

  const isDuo = s.split && s.player1Score !== null && s.player2Score !== null;

  let winner: 'p1' | 'p2' | 'tie' | null = null;
  if (isDuo) {
    if (s.player1Score! > s.player2Score!) winner = 'p1';
    else if (s.player2Score! > s.player1Score!) winner = 'p2';
    else winner = 'tie';
  }

  function panelClass(player: 'p1' | 'p2'): string {
    if (winner === 'tie') return 'ta-go__panel ta-go__panel--tie';
    if (winner === player) return 'ta-go__panel ta-go__panel--winner';
    return 'ta-go__panel ta-go__panel--loser';
  }

  return (
    <div id={d.gameOverRoot} className="target-attack-gameover" hidden={!s.gameOverVisible}>
      {isDuo ? (
        <div className="ta-go__duo">
          <div className={panelClass('p1')}>
            {winner === 'p1' && <div className="ta-go__crown" aria-hidden>🏆</div>}
            <div className="ta-go__player-name">P1</div>
            <div className="ta-go__player-score">{s.player1Score}</div>
            {winner === 'p1' && <div className="ta-go__winner-label">{t('game.winner')}</div>}
            {winner === 'tie' && <div className="ta-go__tie-label">{t('game.tie')}</div>}
          </div>

          <div className={panelClass('p2')}>
            {winner === 'p2' && <div className="ta-go__crown" aria-hidden>🏆</div>}
            <div className="ta-go__player-name">P2</div>
            <div className="ta-go__player-score">{s.player2Score}</div>
            {winner === 'p2' && <div className="ta-go__winner-label">{t('game.winner')}</div>}
            {winner === 'tie' && <div className="ta-go__tie-label">{t('game.tie')}</div>}
          </div>
        </div>
      ) : (
        <>
          <h2 className="target-attack-gameover__title">{t('game.game_over')}</h2>
          <div className="target-attack-gameover__score">{t('game.score')} {s.score}</div>
        </>
      )}
    </div>
  );
}
